import { render, staticRenderFns } from "./CreateProxyUserBan.vue?vue&type=template&id=7596fb11&"
import script from "./CreateProxyUserBan.vue?vue&type=script&lang=ts&"
export * from "./CreateProxyUserBan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports